import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { MessageCircle } from "react-feather";
import { BasicMapTitle } from "../../../../../Constants/Constants";
import { PlusCircle } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import CreateActivityForm from "./CreateActivityForm";

interface ModalProps {
  ApplNo: string;
  isOpen: boolean;
  toggle?: () => void;
}

const CreateActivityModal: React.FC<ModalProps> = ({ ApplNo, isOpen, toggle }) => {

  return (
    <>
      <Modal size="md" isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Add Activity</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">Add a new recruitment activity to keep the applicant's timeline up to date.</P>
          </ModalHeader>
          <CreateActivityForm ApplNo={ApplNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default CreateActivityModal;
